<template>
  <v-btn-toggle
    v-if="assayView && assayView.chemicals && assayView.chemicals.length"
    v-model="assayView.view"
    dense
  >
    <v-btn
      title="ToxPrints"
      v-b-tooltip
      aria-label="ToxPrints"
    >
      <v-icon>mdi-foot-print</v-icon>
    </v-btn>
    <v-btn
      title="ChemoType Enrichment Metrics"
      v-b-tooltip
      aria-label="ChemoType Enrichment Metrics"
    >
      <v-icon>mdi-chart-box-outline</v-icon>
    </v-btn>
    <template v-if="assayView.toxprintsDefaultProfile === assayView.assay.options.profile">
      <v-btn
        :disabled="!assayView.chemical"
        title="Single chemical profile of shared ToxPrint enrichments in ToxCast/Tox21 assays"
        v-b-tooltip
        aria-label="Single chemical profile of shared ToxPrint enrichments in ToxCast/Tox21 assays"
      >
        <v-icon>mdi-chart-bar-stacked</v-icon>
      </v-btn>
      <v-btn
        title="Chemical list summary profile of shared ToxPrint enrichments in ToxCast/Tox21 assays"
        v-b-tooltip
        aria-label="Chemical list summary profile of shared ToxPrint enrichments in ToxCast/Tox21 assays"
      >
        <v-icon>mdi-table</v-icon>
      </v-btn>
    </template>
  </v-btn-toggle>
</template>

<script>
export default {
  props: {
    assayView: {
      type: Object,
      default: null,
    },
  },
}
</script>
